import { IngredientSupplier } from "src/api/client-api/ingredients/useGetOneIngredient";

/**
 * NOTE — Extracted from `IngredientScores.tsx` so that the latter only exports
 * the `IngredientScores` React component, keeping it compatible with Vite React
 * Fast Refresh's "consistent components exports" rule. Mixing a plain helper
 * (`getNumberOfSuppliers`) with a component export in the same module breaks
 * HMR.
 *
 * See https://github.com/vitejs/vite-plugin-react-swc#consistent-components-exports
 */
export const getNumberOfSuppliers = (suppliers: IngredientSupplier[] | undefined) => {
    if (!suppliers) return 0;

    return suppliers.length;
};
